import YhBreadcrumb from './src/breadcrumb.vue'

export * from './types'
export default YhBreadcrumb
